// @/composables/useSizing.js
import { ref, onMounted, onUnmounted } from 'vue'

export default function useSizing() {
  const isMobile = ref(false)
  
  const updateScreenSize = () => {
    isMobile.value = window.innerWidth <= 768
  }

  onMounted(() => {
    updateScreenSize()
    window.addEventListener('resize', updateScreenSize)
  })
  
  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenSize)
  })
  
  return {
    isMobile
  }
}